// Chakra Imports
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Link,
  useColorModeValue,
  Image,
  useToken,
  Button,
  AspectRatio,
  ModalOverlay,
  Modal,
  ModalContent,
  useDisclosure,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import AdminNavbarLinks from "./AdminNavbarLinks";
import { Navigate, Link as ReactRouterLink, useLocation } from "react-router-dom";
import { USER_SIDEBAR_MENU } from "constants/user-profile";
import SidebarResponsive from "components/Sidebar/SidebarResponsive";
import { useTranslation } from "react-i18next";
import { useDefaultShakhsSherkat } from "context/ShakhsContext";
import { getTutorialVideo } from "constants/Tutorialvideos";
//import topbar from "assets/img/topbar.png";

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const { t } = useTranslation();
  const { defaultShakhs, loadDefault } = useDefaultShakhsSherkat();

  const { variant, children, fixed, secondary, brandText, onOpen, ...rest } =
    props;
const {
    isOpen: isVideoOpen,
    onOpen: onVideoOpen,
    onClose: onVideoClose,
  } = useDisclosure();
  const location = useLocation();
  // ویدیوی آموزشی متناظر با صفحه‌ی فعلی (نگاشت در constants/tutorialVideos.js)
  const TUTORIAL_VIDEO_URL = getTutorialVideo(location.pathname);
  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  const [navbarShadow] = useToken("colors", ["navbar_shadow"]);
  const [navbarBg] = useToken("colors", ["navbar_bg"]);
  const [mainText] = useToken("colors", ["navbar_main_text"]);
  const [secondaryText] = useToken("colors", ["nabar_secondry_text"]);
  const [navbarBorder] = useToken("colors", ["navbar_border_color"]);
  const [navbarFilter] = useToken("colors", ["navbar_filter"]);
  let navbarPosition = "absolute";
  let navbarBackdrop = "blur(21px)";
  let secondaryMargin = "0px";
  let paddingX = "15px";
  if (props.fixed === true)
    //if (scrolled === true) {
    navbarPosition = "fixed";
  //}
  if (props.secondary) {
    navbarBackdrop = "none";
    navbarPosition = "absolute";
    mainText = "white";
    secondaryText = "white";
    secondaryMargin = "22px";
    paddingX = "30px";
  }
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };
  /* window.addEventListener("scroll", changeNavbar); */
  useEffect(() => {
    window.addEventListener("scroll", changeNavbar);

    return () => {
      window.removeEventListener("scroll", changeNavbar);
    };
  }, []);

  const extraPath = window.location.href.includes("_ref")
    ? "edit"
    : window.location.href.includes("_el")
      ? "eslah"
      : window.location.href.includes("_e")
        ? "delete"
        : window.location.href.includes("_rn")
          ? "return"
          : window.location.href.substring(
                window.location.href.lastIndexOf("/") + 1,
              ) === "add"
            ? "add"
            : null;

  useEffect(() => {
    if (brandText.name === "شخص/ شرکت" || brandText.name === "صفحه اصلی")
      loadDefault();
  }, [brandText.name]);
  return (
    <Flex
      zIndex={999}
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      border="1px solid"
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ lg: "center" }}
      borderRadius="8px"
      display="flex"
      minH="30px"
      justifyContent={{ lg: "center" }}
      lineHeight="25.6px"
      mx="auto"
      mt={secondaryMargin}
      pr={3}
      /* py={{base:2 , lg: 4}} */
      top="15px"
      w={{ sm: "calc(100vw - 35px)", lg: "calc(100% -  290px)" }}
      flex="1"
    >
      <Flex w="100%" alignItems={{ lg: "center" }}>
        <SidebarResponsive
          logoText={props.logoText}
          secondary={props.secondary}
          routes={USER_SIDEBAR_MENU}
          // logo={logo}
          {...rest}
        />

        <Box
          mb={{ sm: "8px", md: "0px" }}
          display={{ sm: "none", lg: "block" }}
        >
          <Breadcrumb>
            <BreadcrumbItem color={mainText}>
              <BreadcrumbLink
                as={ReactRouterLink}
                color={secondaryText}
                to="/user/dashboard"
              >
                صفحه اصلی
              </BreadcrumbLink>
            </BreadcrumbItem>
            {brandText.name !== "صفحه اصلی" && (
              <BreadcrumbItem gap={2} color={mainText}>
                <BreadcrumbLink
                  as={ReactRouterLink}
                  color={mainText}
                  to={brandText.path}
                >
                  {brandText.name} [{defaultShakhs.name}]
                </BreadcrumbLink>
                
              </BreadcrumbItem>
            )}
            {extraPath && (
              <BreadcrumbItem color={mainText}>
                <BreadcrumbLink color={secondaryText}>
                  {t(extraPath)}
                </BreadcrumbLink>
              </BreadcrumbItem>
            )}
           {TUTORIAL_VIDEO_URL && (
             <Button
               fontSize={"xs"}
               ml={{ base: 2, md: 2 }}
               size={"sm"}
               bg={"button_teal_bg"}
               color= "button_teal_color"
               _hover={{
                 bg: "button_teal_hover",
                 
               }}
               colorScheme="teal"
               borderRadius={"6px"}
               onClick={onVideoOpen}
             >
               ویدیو آموزشی
             </Button>
           )}
          </Breadcrumb>

      {TUTORIAL_VIDEO_URL && (
      <Modal isOpen={isVideoOpen} onClose={onVideoClose} size="6xl" isCentered>
        <ModalOverlay
  bg="blackAlpha.300"
  backdropFilter="blur(8px)"
/>
        <ModalContent bg="black" borderRadius="12px" overflow="hidden">
          <ModalCloseButton color="white" zIndex={1} />
          <ModalBody p={0}>
            <AspectRatio ratio={16 / 9}>
              <video
                src={TUTORIAL_VIDEO_URL}
                controls
                autoPlay
                style={{ width: "100%", height: "100%" }}
              >
                این ویدیو توسط مرورگر شما پشتیبانی نمی‌شود
              </video>
            </AspectRatio>
          </ModalBody>
        </ModalContent>
      </Modal>
      )}
          {/* Here we create navbar brand, based on route name */}
          {/* <Link
            color={mainText}
            href="#"
            bg="inherit"
            borderRadius="inherit"
            fontWeight="bold"
            _hover={{ color: { mainText } }}
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
          >
            {brandText}
          </Link> */}
        </Box>
        <Box ms="auto" w={{ lg: "unset" }}>
          <AdminNavbarLinks
  navbarBg
  onOpen={props.onOpen}
  logoText={props.logoText}
  secondary={props.secondary}
  fixed={props.fixed}
  planName={defaultShakhs?.planName}
/>
        </Box>
      </Flex>
    </Flex>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};